import PropTypes from 'prop-types';
import React from 'react';
import { Conductor } from '@opendate-app/setlist';

const ConductorAvatar = ({ size = 28, animated = false, showBackground = true }) => {
  const animation = animated ? 'constellation-twinkle' : undefined;

  if (!showBackground) {
    return <Conductor width={size} height={size} animation={animation} />;
  }

  const iconSize = Math.max(size - 10, 12);

  return (
    <div style={{
      width: `${size + 4}px`,
      height: `${size + 4}px`,
      borderRadius: '50%',
      background: '#f5f5f5',
      border: '1px solid #e9eaeb',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    }}>
      <Conductor width={iconSize} height={iconSize} animation={animation} />
    </div>
  );
};

ConductorAvatar.propTypes = {
  size: PropTypes.number,
  animated: PropTypes.bool,
  showBackground: PropTypes.bool
};

export default ConductorAvatar;
